import { render } from "./ChargesList.vue?vue&type=template&id=704146c6&scoped=true"
import script from "./ChargesList.vue?vue&type=script&lang=js"
export * from "./ChargesList.vue?vue&type=script&lang=js"

import "./ChargesList.vue?vue&type=style&index=0&id=704146c6&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704146c6"]])

export default __exports__